<template>
	<div id="container">
		<h2>{{ dspHead[lang] }}</h2>
		<div v-for="(doz, i) in dsp" :key="i">
			<h3>{{ doz }}</h3>
			<table id="table1" class="reflow">
				<thead>
					<tr>
						<th></th>
						<th v-html="uniLabel[lang][0]"></th>
						<th v-html="uniLabel[lang][1]"></th>
						<th v-html="uniLabel[lang][2]"></th>
						<th v-html="uniLabel[lang][3]"></th>
						<th v-html="uniLabel[lang][4]"></th>
					</tr>
				</thead>
				<tbody v-for="item in items" :key="item.id + i * items.length">
					<tr class="customHeader" v-if="item.values !== undefined && item.values.length > 0">
						<td></td>
						<td class="center">{{ item.values[0] }}</td>
						<td class="center">{{ item.values[1] }}</td>
						<td class="center">{{ item.values[2] }}</td>
						<td class="center">{{ item.values[3] }}</td>
						<td class="center">{{ item.values[4] }}</td>
					</tr>
					<mc @add:response="addResponse" :item="{ text: item.text, id: item.id + i * items.length, values: item.values }" />
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import mc from "@/components/items/mc-uni.vue";
import { mapGetters } from "vuex";

export default {
	name: "dsp-block",
	components: {
		mc,
	},
	props: {
		items: Array,
		dsp: Array,
	},
	methods: {
		addResponse(response) {
			this.$emit("add:response", response);
		},
	},
	computed: mapGetters(["uniLabel", "lang", "dspHead"]),
};
</script>

<style scoped>
#container {
	margin: 1rem 0 0 0;
}
h2 {
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 0.7rem;
}
h3 {
	font-weight: 600;
	margin-top: 0.5rem;
}
table.reflow {
	width: 98%;
}

table.reflow th {
	width: calc(65vw / 5);
	word-break: break-word;
	background: white;
	text-align: center;
	border-bottom: 1px dashed silver;
}
.center {
	text-align: center;
}
.customHeader {
	margin-top: 0.5rem;
}

@media screen and (max-width: 480px) {
	table.reflow {
		width: 100%;
		margin: 3vw 0 0 0;
	}
	table.reflow th {
		display: none;
	}
	.customHeader {
		display: none;
	}
}
</style>
